module.exports = __webpack_public_path__ + "static/media/thumb.a964ff69.svg";